import { fetchWithAuth } from './config';

const getUsers = async () => {
  const users = await fetchWithAuth('/users');

  return users;
};

export {
  getUsers,
};
